import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx-js-style';
import { WorkSheet } from 'xlsx-js-style';

@Injectable({
  providedIn: 'root',
})

export class ExcelService {

  constructor() { }

  public static exportAsExcelFile(json: any[], excelFileName: string): string {
    const worksheet: WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

    // Create a URL and return
    const url: string = window.URL.createObjectURL(data);
    return url;
  }
}
